module.exports = "../../app/cells/components/summary_suggestions_cell.rb";